"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-two/sections/specialitySectionTwo.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type SpecialitySectionTwo36sItem = {
    key: Key | null | undefined;
    /** Detected variants: "$0" | "$39" */
    div0Text: ReactNode;
    /** Detected variants: "Free" | "Basic" */
    p0Text: ReactNode;
    /** Detected variants: "col-xl-3 col-md-6 d-flex" */
    className?: string;
    /** Detected variants: "price-item flex-fill wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "price-header" */
    div0ClassName2?: string;
    /** Detected variants: "price" */
    div0ClassName3?: string;
    /** Detected variants: "/monthly" */
    span0Text?: ReactNode;
    /** Detected variants: "Get Started" */
    link0Text?: ReactNode;
    /** Detected variants: "btn btn-md btn-dark" */
    link0ClassName?: string;
    /** Detected variants: "all_routes.login" */
    href?: string;
    /** Detected variants: "sub-title" */
    p0ClassName?: string;
    /** Detected variants: "price-body" */
    div1ClassName?: string;
    /** Detected variants: "What’s included" */
    h30Text?: ReactNode;
    priceBodyItems?: SpecialitySectionTwoUlsItem[];
};

type SpecialitySectionTwoUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "1 Users" | "EMR / EHR" | "Billing & Payments" | "Family Account Management" | "Order Tests, Track Samples" | "Report Generation" | "10 Users" | "Pharmacy Access" | "Automate Billing" | "Analytics & Reports" */
    liText: ReactNode;
};

type SpecialitySectionTwoUls3Item = {
    key: Key | null | undefined;
    /** Detected variants: "100 Users" | "Billing & Invoicing" | "Dedicated Support" | "Family Account Management" | "Order Tests, Track Samples" | "Analytics & Reports" */
    liText: ReactNode;
};

type SpecialitySectionTwoUls4Item = {
    key: Key | null | undefined;
    /** Detected variants: "Unlimited Users" | "Pharmacy Access" | "Dedicated Support" | "Family Account Management" | "Order Tests, Track Samples" | "Analytics & Reports" */
    liText: ReactNode;
};
export type HomeTwoSpecialitySectionTwoGeneratedProps = {
    divDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: SpecialitySectionTwo36sItem) => Partial<ComponentProps<typeof SmartLink>>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: SpecialitySectionTwo36sItem) => Partial<ComponentProps<"h3">>);
    /** Default: "Pricing Plan" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "icon" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/section-icon.svg" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Choose the" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Plans of your Needs" */
    sectionDiv0Div0H20Span0SpanText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div1Div2Div0DivDataWowDuration?: string;
    /** Default: "$99" */
    sectionDiv0Div1Div2Div0Div0Div0DivText?: ReactNode;
    /** Default: "/monthly" */
    sectionDiv0Div1Div2Div0Div0Div0Span0SpanText?: ReactNode;
    /** Default: "all_routes.login" */
    sectionDiv0Div1Div2Div0Div0Link0LinkHref?: string;
    /** Default: "Get Started" */
    sectionDiv0Div1Div2Div0Div0Link0LinkText?: ReactNode;
    /** Default: "Premium" */
    sectionDiv0Div1Div2Div0Div0P0PText?: ReactNode;
    /** Default: "What’s included" */
    sectionDiv0Div1Div2Div0Div1H30H3Text?: ReactNode;
    /** Default: "Recommended" */
    sectionDiv0Div1Div2Div0Span0SpanText?: ReactNode;
    /** Default: "1s" */
    sectionDiv0Div1Div3Div0DivDataWowDuration?: string;
    /** Default: "$129" */
    sectionDiv0Div1Div3Div0Div0Div0DivText?: ReactNode;
    /** Default: "/monthly" */
    sectionDiv0Div1Div3Div0Div0Div0Span0SpanText?: ReactNode;
    /** Default: "all_routes.login" */
    sectionDiv0Div1Div3Div0Div0Link0LinkHref?: string;
    /** Default: "Get Started" */
    sectionDiv0Div1Div3Div0Div0Link0LinkText?: ReactNode;
    /** Default: "Enterprise" */
    sectionDiv0Div1Div3Div0Div0P0PText?: ReactNode;
    /** Default: "What’s included" */
    sectionDiv0Div1Div3Div0Div1H30H3Text?: ReactNode;
    specialitySectionTwo36s: SpecialitySectionTwo36sItem[];
    specialitySectionTwoUls3: SpecialitySectionTwoUls3Item[];
    specialitySectionTwoUls4: SpecialitySectionTwoUls4Item[];
    specialitySectionTwo36sItemWrapper?: (item: SpecialitySectionTwo36sItem, content: ReactNode) => ReactNode;
    specialitySectionTwo36sRenderer?: (defaultNode: ReactNode) => ReactNode;
    specialitySectionTwo36sLinkVisible?: boolean;
    specialitySectionTwo36sLinkRenderer?: (item: SpecialitySectionTwo36sItem, defaultNode: ReactNode) => ReactNode;
    specialitySectionTwo36sH3Visible?: boolean;
    specialitySectionTwo36sH3Renderer?: (item: SpecialitySectionTwo36sItem, defaultNode: ReactNode) => ReactNode;
    specialitySectionTwo36sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: SpecialitySectionTwo36sItem) => Partial<ComponentProps<typeof SmartLink>>);
    specialitySectionTwo36sH3Props?: Partial<ComponentProps<"h3">> | ((item: SpecialitySectionTwo36sItem) => Partial<ComponentProps<"h3">>);
    specialitySectionTwoUlsItemWrapper?: (item: SpecialitySectionTwoUlsItem, content: ReactNode) => ReactNode;
    specialitySectionTwoUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
    specialitySectionTwoUls3ItemWrapper?: (item: SpecialitySectionTwoUls3Item, content: ReactNode) => ReactNode;
    specialitySectionTwoUls3Renderer?: (defaultNode: ReactNode) => ReactNode;
    specialitySectionTwoUls4ItemWrapper?: (item: SpecialitySectionTwoUls4Item, content: ReactNode) => ReactNode;
    specialitySectionTwoUls4Renderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeTwoSpecialitySectionTwoGenerated: FC<HomeTwoSpecialitySectionTwoGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "Pricing Plan",
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt = "icon",
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/section-icon.svg",
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0H20H2Text = "Choose the",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0SpanText = "Plans of your Needs",
    sectionDiv0Div1Div2Div0Div0Div0DivText = "$99",
    sectionDiv0Div1Div2Div0Div0Div0Span0SpanText = "/monthly",
    sectionDiv0Div1Div2Div0Div0Link0LinkHref = "all_routes.login",
    sectionDiv0Div1Div2Div0Div0Link0LinkText = "Get Started",
    sectionDiv0Div1Div2Div0Div0P0PText = "Premium",
    sectionDiv0Div1Div2Div0Div1H30H3Text = "What’s included",
    sectionDiv0Div1Div2Div0DivDataWowDuration = "1s",
    sectionDiv0Div1Div2Div0Span0SpanText = "Recommended",
    sectionDiv0Div1Div3Div0Div0Div0DivText = "$129",
    sectionDiv0Div1Div3Div0Div0Div0Span0SpanText = "/monthly",
    sectionDiv0Div1Div3Div0Div0Link0LinkHref = "all_routes.login",
    sectionDiv0Div1Div3Div0Div0Link0LinkText = "Get Started",
    sectionDiv0Div1Div3Div0Div0P0PText = "Enterprise",
    sectionDiv0Div1Div3Div0Div1H30H3Text = "What’s included",
    sectionDiv0Div1Div3Div0DivDataWowDuration = "1s",
    divDiv0Div0Link0LinkProps,
    divDiv0Div1H30H3Props,
    sectionDiv0Div1ClassName,
    specialitySectionTwo36s,
    specialitySectionTwoUls3,
    specialitySectionTwoUls4,
    specialitySectionTwo36sItemWrapper,
    specialitySectionTwo36sRenderer,
    specialitySectionTwo36sLinkVisible,
    specialitySectionTwo36sLinkRenderer,
    specialitySectionTwo36sH3Visible,
    specialitySectionTwo36sH3Renderer,
    specialitySectionTwo36sLinkProps,
    specialitySectionTwo36sH3Props,
    specialitySectionTwoUlsItemWrapper,
    specialitySectionTwoUlsRenderer,
    specialitySectionTwoUls3ItemWrapper,
    specialitySectionTwoUls3Renderer,
    specialitySectionTwoUls4ItemWrapper,
    specialitySectionTwoUls4Renderer,
}) => {
    return (
        <section className="section speciality-section-two">
            <div className="container">
                <div className="section-header section-header-two">
                    <div className="section-sub-title">
                        {renderNode(sectionDiv0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0ImageWithBasePath0ImageAlt} {...(sectionDiv0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                        {sectionDiv0Div0Div0DivText}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title mb-0" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <span>{sectionDiv0Div0H20Span0SpanText}</span>
                        </h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row align-items-end g-4"}>
                    {renderCollectionNode(
                        specialitySectionTwo36s,
                        (item: SpecialitySectionTwo36sItem) => (
                            <div className={item.className ?? "col-xl-3 col-md-6 d-flex"} key={item.key}>
                                <div className={item.div0ClassName ?? "price-item flex-fill wow fadeInUp"} data-wow-duration={item.dataWowDuration ?? "1s"}>
                                    <div className={item.div0ClassName2 ?? "price-header"}>
                                        <p className={item.p0ClassName ?? "sub-title"}>{item.p0Text}</p>
                                        <div className={item.div0ClassName3 ?? "price"}>
                                            {item.div0Text}
                                            <span>{item.span0Text ?? "/monthly"}</span>
                                        </div>
                                        {renderItemNode(specialitySectionTwo36sLinkVisible, specialitySectionTwo36sLinkRenderer, item, (
                                            <SmartLink href={item.href ?? "all_routes.login"} className={item.link0ClassName ?? "btn btn-md btn-dark"} {...(typeof specialitySectionTwo36sLinkProps === "function" ? specialitySectionTwo36sLinkProps(item) : (specialitySectionTwo36sLinkProps ?? {}))} {...(typeof divDiv0Div0Link0LinkProps === "function" ? divDiv0Div0Link0LinkProps(item) : (divDiv0Div0Link0LinkProps ?? {}))}>{item.link0Text ?? "Get Started"}</SmartLink>
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "price-body"}>
                                        {renderItemNode(specialitySectionTwo36sH3Visible, specialitySectionTwo36sH3Renderer, item, (
                                            <h3 {...(typeof specialitySectionTwo36sH3Props === "function" ? specialitySectionTwo36sH3Props(item) : (specialitySectionTwo36sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>{item.h30Text ?? "What’s included"}</h3>
                                        ))}
                                        <ul>
                                            {renderCollectionNode(
                                                item.priceBodyItems ?? [],
                                                (item: SpecialitySectionTwoUlsItem) => (
                                                    <li key={item.key}>{item.liText}</li>
                                                ),
                                                specialitySectionTwoUlsItemWrapper,
                                                specialitySectionTwoUlsRenderer
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        ),
                        specialitySectionTwo36sItemWrapper,
                        specialitySectionTwo36sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeTwoSpecialitySectionTwoGenerated;
